import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/ui/Button';
import CountrySelector from './components/CountrySelector';
import LanguageSelector from './components/LanguageSelector';
import ProgressIndicator from './components/ProgressIndicator';

const CountryLanguageSelection = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('common');
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState(null);

    const handleContinue = () => {
        if (selectedCountry && selectedLanguage) {
            // Store selections in localStorage for next step
            localStorage.setItem('registrationData', JSON.stringify({
                country: selectedCountry,
                language: selectedLanguage,
                timestamp: new Date().toISOString()
            }));

            navigate('/name-email-registration');
        }
    };

    const handleBackToLogin = () => {
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div className="flex justify-center mb-4">
                        <img
                            src="/static/frontend/assets/images/Giftsy-Logo-Final-1751671984839.png"
                            alt="Giftsy Modern"
                            className="h-16 w-auto"
                        />
                    </div>
                    <h1 className="text-2xl font-heading font-bold text-accent-800 mb-2">
                        Welcome to Giftsy
                    </h1>
                    <p className="text-accent-600 text-base">
                        Choose your country and language to get started
                    </p>
                </div>

                {/* Progress Indicator */}
                <ProgressIndicator currentStep={1} totalSteps={3} />

                {/* Selection Card */}
                <div className="bg-white rounded-xl shadow-soft p-6 mb-6">
                    {/* Country Selection */}
                    <div className="mb-8">
                        <h2 className="text-lg font-semibold text-accent-800 mb-4">
                            Select Your Country
                        </h2>
                        <CountrySelector
                            selectedCountry={selectedCountry}
                            onCountrySelect={setSelectedCountry}
                        />
                    </div>

                    {/* Language Selection */}
                    <div className="mb-8">
                        <h2 className="text-lg font-semibold text-accent-800 mb-4">
                            Choose Your Language
                        </h2>
                        <LanguageSelector
                            selectedLanguage={selectedLanguage}
                            onLanguageSelect={setSelectedLanguage}
                            selectedCountry={selectedCountry}
                        />
                    </div>

                    {/* Continue Button */}
                    <Button
                        onClick={handleContinue}
                        disabled={!selectedCountry || !selectedLanguage}
                        fullWidth
                        variant="primary"
                        size="lg"
                        className="mb-4"
                    >
                        Continue
                    </Button>

                    {/* Back to Login Link */}
                    <div className="text-center">
                        <button
                            onClick={handleBackToLogin}
                            className="text-accent-600 hover:text-primary-600 text-sm font-medium transition-colors"
                        >
                            Already have an account? Sign in
                        </button>
                    </div>
                </div>

                {/* Cultural Sensitivity Note */}
                <div className="text-center text-xs text-accent-500 max-w-sm mx-auto">
                    We respect your cultural preferences and will adapt our experience accordingly.
                </div>
            </div>
        </div>
    );
};

export default CountryLanguageSelection; 